<template>
    <div class="row mb-3">
        <div class="col-4 mr-2">
            <ul class="list-group list-group-flush font-weight-normal" v-if="leftDescriptionTable.length > 0">
                <li class="list-group-item p-1">Keterangan Kolom: </li>
                <li class="list-group-item p-1" v-for="(desc, index) in leftDescriptionTable" :key="index">
                    <span :class="desc.bg" class="px-4 py-1 mr-2"></span>{{ desc.lable }}
                </li>
                <li class="list-group-item p-1"></li>
            </ul>
        </div>
        <div class="col-4">
            <ul class="list-group list-group-flush font-weight-normal" v-if="rightDescriptionTable.length > 0">
                <li class="list-group-item p-1">Keterangan Status Data: : </li>
                <li class="list-group-item p-1" v-for="(desc, index) in rightDescriptionTable" :key="index">
                    <span :class="desc.bg" class="px-4 py-1 mr-2"></span>{{ desc.lable }}
                </li>
                <li class="list-group-item p-1"></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TableInformation1',
    props: {
        leftDescriptionTable: {
            type: Array,
            required: true
        },
        rightDescriptionTable: {
            type: Array,
            required: true
        },
    },
};
</script>